<section class="authenticatorSection">
    <div class="auth">
        <!-- <div class="logo-container">
            <img src="/assets/images/Afrisurelogo.svg" alt="Active Image">
        </div> -->
        <div class="text-center mb-3 mt-5">
             <h5>{{currentLoginAuthenticationSelected.mfaAuthenticationTypeName}} Verification</h5>
        </div>

        <form [formGroup]="otpForm" autocomplete="new-form">
                <div *ngIf="!isGoogleAuthenticatorRegistered  && isGoogleAuthenticatorIsSetToPrimaryOrSelected">
                    <p style="text-align:center" >
                        {{'Authentication_tokens'|translate}}
                        <a class="colorblue"
                            href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US"
                            target="_blank" rel="noopener">
                            {{'Google_Authenticator'|translate}}
                        </a>
                        {{'Play_Store_message'|translate}}
                    </p>
                    <div style=" margin-left: 30%; width: 50%; ">
                        <img src="{{barcodeImageUrl}}" style="width: 75%" alt=""/>
                    </div>
                </div>
          

            <p *ngIf="isGoogleAuthenticatorRegistered && isGoogleAuthenticatorIsSetToPrimaryOrSelected" class="text-center mt-2 mb-1">
                {{'otp_google_authentication' | translate}}</p>
            <p class="text-center mt-2 mb-1" *ngIf="!isGoogleAuthenticatorIsSetToPrimaryOrSelected && otpPromptMessage">{{otpPromptMessage}}</p>
         
            <div class="classfifty input-group form-group justify-content-center mt-2">
                <div class="input-group-prepend mb-2 mb-sm-0">
                    <span class="input-group-text colordiv"><i class="fa fa-lock lockIcon colordiv"></i></span>
                </div>
                <div class="otp-input-container">
                    <div *ngFor="let i of [0, 1, 2, 3, 4, 5]; let index = index" class="otp-input-box">
                        <input #otpInput type="tel" minlength="1" maxlength="1" (keypress)="numberOnly($event, index)"
                            (input)="onInputChange($event,'otp' + index)" [id]="'otp' + index"
                            (keydown)="onBackspaceKeyDown($event, index)" [formControlName]="'otp' + index"
                            (keyup)="onOtpInput(index)">
                    </div>
                </div>
                <div *ngIf="control['otp'].errors && submitted" class="text-center">
                    <div *ngIf="control['otp'].errors['required']" class="text-danger letterspacing">
                        {{'OTP_is_required'|translate}} </div>
                </div>
            </div>
            
            

            <div class="mt-2 text-end">
                    <div *ngFor="let authentication of getuserAuthentication" class="text-end">
                        <a class="font_size15px" *ngIf="authentication.mfaAuthenticationTypeID != currentLoginAuthenticationSelected.mfaAuthenticationTypeID"
                            href="javascript:void(0)" (click)="changeAuthenticationType(authentication)">
                            Switch to {{authentication.mfaAuthenticationTypeName}}
                         </a>
                    </div>
                
            </div>

            <p class="text-center mb-1 mt-3" *ngIf="showResend==false && !isGoogleAuthenticatorIsSetToPrimaryOrSelected">{{'OTP_request' | translate}}</p>
            <div class="load" *ngIf="showResend==false && !isGoogleAuthenticatorIsSetToPrimaryOrSelected">
                <div class="progress-time mx-4" [style.--progress-value]="timeRemaining_percent">
                    <progress style="visibility:hidden;height:0;width:0;"></progress>
                    <span class="progress-value">{{remainingTime}}</span>
                </div>
            </div>
            <div class="text-center m-2" *ngIf="showResend==true && !isGoogleAuthenticatorIsSetToPrimaryOrSelected">
                <p class="mt-3">{{'OTP_Question' | translate}} <a href="javascript: void(0)"
                        (click)="resendOtp()">{{'Resend_OTP' | translate}}</a></p>

            </div>
            <div class="form-group text-center my-2 mt-4 submit">
                <button class="classfifty btn btn-block btnreset capitilize letterSpacing m-1"
                    (click)="goBack()" type="reset"><em class="fa fa-fw fa-arrow-left"></em>
                    {{'Go_Back'|translate}}
                </button>&nbsp;
                <button type="submit" class="classfifty btn btnc btn-block  letterSpacing m-1" (click)="otpVerify()"><em
                        class="fa fa-fw fa-key"></em>
                    {{'Validate_OTP'|translate}}
                </button>

            </div>
        </form>

    </div>
</section>